import MatchTeam from "./matchTeam";
import "./matchRow.sass";

export default function MatchRow({ match, groupId, onChangeScore }) {
  const { id, home, home_flag, homeScore, away, away_flag, awayScore, locked, venue, phase } = match;

  return (
    <div className={`MatchRow ${locked ? "is-locked" : ""}`}>
      <div className="MatchTeams">
        <MatchTeam
          groupId={groupId}
          matchId={id}
          name={home}
          flag={home_flag}
          score={homeScore}
          scoreField="homeScore"
          onChangeScore={onChangeScore}
          clase="home"
          locked={locked}
        />

        <span className="MatchDash">-</span>

        <MatchTeam
          groupId={groupId}
          matchId={id}
          name={away}
          flag={away_flag}
          score={awayScore}
          scoreField="awayScore"
          onChangeScore={onChangeScore}
          clase="away"
          locked={locked}
        />
      </div>
      {(venue || phase) && (
        <div className="MatchDetails">
          {phase && <span className="MatchPhase">{phase}</span>}
          {venue && phase && <span>|</span>}
          {venue && <span className="MatchVenue">{venue}</span>}
        </div>
      )}
    </div>
  );
}